module.exports = __webpack_public_path__ + "img/logo-white.cc4cd219.svg";